import { request } from './networking'

const BASE_URL = 'adalo.com'

const findMainKeyByActionId = (json, actionId) => {
  for (const key in json) {
    const value = json[key]
    if (value && typeof value === 'object') {
      // Check if the current object contains actions
      if (value.actions) {
        for (const actionKey in value.actions) {
          const action = value.actions[actionKey]
          if (action.actions) {
            for (const subAction of action.actions) {
              if (subAction.id === actionId) {
                return key // Return the key that contains the actionId
              }
            }
          }
        }
      }
      // Recursively search nested objects
      const nestedResult = findMainKeyByActionId(value, actionId)
      if (nestedResult) {
        return key // Return the top-level key if a match is found in nested objects
      }
    }
  }
  return null
}

const buildResult = (meta, data) => {
  const result = {}

  // Process each key in meta.query
  Object.keys(meta.query).forEach(key => {
    if (key in data) {
      const fieldName = meta.query[key].value
      const fieldValue = data[key].value
      result[fieldName] = fieldValue
    }
  })

  if (Object.keys(result).length === 0) {
    console.error('No matching keys found between meta.query and data')
    return null
  }

  return result
}

// ─── Helper utilities ────────────────────────────────────────────────
const getScreenId = (components, actionId) =>
  findMainKeyByActionId(components, actionId) || null

const getAliasForScreen = (aliases, screenId) =>
  screenId
    ? Object.keys(aliases).find(a => screenId === aliases[a].componentId) ||
      null
    : null

const buildQueryString = params =>
  Object.entries(params)
    .map(([k, v]) => {
      const cleanValue = typeof v === 'string' ? v.replace(/,/g, '') : v
      return `${encodeURIComponent(k)}=${encodeURIComponent(cleanValue)}`
    })
    .join('&')

const buildDomainUrl = (subdomain, path, alias, qs) => {
  return `${subdomain}/${[path, alias].filter(Boolean).join('/')}${qs}`
}

const buildMobileUrl = (orgSub, base, path, alias, qs) =>
  `${orgSub}.${base}/${[path, alias].filter(Boolean).join('/')}${qs}`

const buildUrl = async (app, actionId, deps, isWeb, datasourceId, baseURL) => {
  try {
    /* 1. Find screen and alias */
    const screenId = getScreenId(app.components, actionId)
    if (!screenId) {
      console.error('No screen found for sharing.')
      return null
    }

    const { aliases } = app.deepLinking
    const alias = getAliasForScreen(aliases, screenId)
    if (!alias) {
      console.error('No alias found for sharing.')
      return null
    }

    /* 2. Build query-string parameters */
    const params = buildResult(aliases[alias], deps) || {}
    const qs = Object.keys(params).length ? `?${buildQueryString(params)}` : ''

    // Handle mobile URLs
    if (app.DomainId) {
      // External domain path for mobile
      const apiPath = `${baseURL}/domains/${app.DomainId}/${datasourceId}`
      try {
        const response = await request(datasourceId, apiPath, 'get')
        if (!response || !response.data || !response.data.domain) {
          console.error('Invalid domain response:', response)
          return null
        }
        const subdomain = response.data.domain
        return buildDomainUrl(subdomain, app.path, alias, qs)
      } catch (error) {
        console.error('Error fetching domain:', error)
        return null
      }
    }
    // Hosted by Adalo (or your platform) for mobile
    return buildMobileUrl(
      app.Organization.subdomain,
      BASE_URL,
      app.path,
      alias,
      qs
    )
  } catch (error) {
    console.error('Error building URL:', error)
    return null
  }
}

export const DeepLinkingShare = {
  buildUrl,
}
